import { Dispatch, SetStateAction, useEffect } from 'react';

export type SetFilteredItems = Dispatch<
  SetStateAction<InventoryVirtualMachine[] | InventoryTopologies>
>;

export type UseResetFilterTemplatesWhenTemplatesChange = {
  setFilteredItems: SetFilteredItems;
  templates: InventoryVirtualMachine[] | InventoryTopologies;
};

export const useResetFilterTemplatesWhenTemplatesChange = ({
  setFilteredItems,
  templates,
}: UseResetFilterTemplatesWhenTemplatesChange): void => {
  useEffect(() => {
    setFilteredItems(templates);
  }, [setFilteredItems, templates]);
};
